// extracted by mini-css-extract-plugin
export default {"wrapper":"FAQ_wrapper__9yxC3","title":"FAQ_title__kfKd8","item":"FAQ_item__+12T8","animate":"FAQ_animate__alMXk","animateItem":"FAQ_animateItem__E+Jgp"};